import FiltersHeader from "../../../../Helper/filtersHeader";
import * as Constants from '../../../../Helper/constants/constants';
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { Calender, ChangePatientProfile, Image_Up, Man, Patient } from "../../../../../assets/images";
import Select from 'react-select';
import PatientProfileModal from "../../../Modals/PatientProfileModal";
import { useState } from "react";

const EditPatient = () => {
    const breadcrumData = ['Dashboard', 'Cardiology', 'Patient List', 'Patient View'];
    const breadcrumItem = ['Edit Profile'];
    const options = [{ id: '1' }, { id: '2' }];
    const [profileModal, setProfileModal] = useState(true);

    return (
        <div className="edit_patient_screen">
            <FiltersHeader
                header={Constants.EDIT_PROFILE}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="edit_patient">
                            <div className="img_section">
                                <div className="img_profile">
                                    <Image src={Man} alt="..." />
                                </div>
                                <div className="img_upload">
                                    <Image src={Image_Up} alt="..." />
                                </div>
                            </div>
                            <Form>
                                <Form.Group className="form-group">
                                    <Form.Label>Patient Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Harjinder Singh"
                                    />
                                </Form.Group>
                            </Form>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Father Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Jarnail Singh"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Mother Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Karam Kaur"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Date of Birth</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="DD/MM/YYYY"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                                <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Age</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="75"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                                <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>Gender</h6>
                                        <div className="dropdown_area">
                                            <Select
                                                placeholder="Male"
                                                options={options}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>Blood Group</h6>
                                        <div className="dropdown_area">
                                            <Select
                                                placeholder="B+"
                                                options={options}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>Marital Status</h6>
                                        <div className="dropdown_area">
                                            <Select
                                                placeholder="Married"
                                                options={options}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Occupation</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Diagnose Disease"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>Nationality</h6>
                                        <div className="dropdown_area">
                                            <Select
                                                placeholder="Indian"
                                                options={options}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>House Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="781/2"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                                <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Area</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Gandhi Market"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                                <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Pincode</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="142787"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>District</h6>
                                        <div className="dropdown_area">
                                            <Select
                                                placeholder="Select"
                                                options={options}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>City</h6>
                                        <div className="dropdown_area">
                                            <Select
                                                placeholder="Slect"
                                                options={options}
                                            />
                                        </div>
                                    </div>
                                </Col>
                                <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12}>
                                    <div className="dropdown_box">
                                        <h6>State</h6>
                                        <div className="dropdown_area">
                                            <Select
                                                placeholder="Select"
                                                options={options}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Contact Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="+91 789-788-8982"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                                <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Alter Contact Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="+91 789-788-8982"
                                            />
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                            <Form>
                                <Form.Group className="form-group">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="example@gmail.com"
                                    />
                                </Form.Group>
                            </Form>
                            <div className="btn_area">
                                <Button
                                    className="cancelBtn"
                                    type="button"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    className="submitBtn"
                                    type="button"
                                >
                                    Submit
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <PatientProfileModal show={profileModal} onClose={() => setProfileModal(false)} />
        </div>
    )
};

export default EditPatient;